import { REHYDRATE } from 'redux-persist';
import { createListenerMiddleware } from '@reduxjs/toolkit';

import actions from 'modules/translations/actions';
import { DICTIONARY_LOADERS } from 'models/Dictionaries';
import translationsApi from 'modules/translations/service';
import { AppStartListening } from 'App/ListenerMiddleware';
import { hasShareboxStyle } from 'modules/dealers/selectors';

import { getSelectedLanguage } from './selectors';
import Language from 'types/LanguageEnum';

const listenerMiddleware = createListenerMiddleware();

const startAppListening = listenerMiddleware.startListening as AppStartListening;

// TODO - [TAN][API] Provide an endpoint to load dictionaries or load keyboard suggestions on the fly
const loadDictionaries = async (language: Language) => {
  await DICTIONARY_LOADERS[language]?.();
};

startAppListening({
  type: REHYDRATE,
  effect: async (_, { dispatch, getState }) => {
    const language = getSelectedLanguage(getState());
    dispatch(translationsApi.endpoints.getLanguages.initiate());
    dispatch(
      translationsApi.endpoints.getTranslationsByLanguage.initiate({
        language,
      }, { fixedCacheKey: 'getTranslations' }),
    );

    if (hasShareboxStyle(getState())) {
      await loadDictionaries(language);
    }
  },
});

startAppListening({
  actionCreator: actions.setSelectedLanguage,
  effect: async (_, { dispatch, getState }) => {
    const language = getSelectedLanguage(getState());
    dispatch(translationsApi.endpoints.getTranslationsByLanguage.initiate({
      language,
    }, {
      fixedCacheKey: 'getTranslations',
    }));

    if (hasShareboxStyle(getState())) {
      await loadDictionaries(language);
    }
  },
});

export default listenerMiddleware;
